/**
 * AI budget override schema (#18, spec §9 Cost Controls).
 *
 * Body shape for `POST /api/admin/ai/override-budget`. The spec restricts
 * the override window to either 1 hour (a quick "let me ship this one
 * page" override) or 24 hours (a hard day where the operator wants the
 * cap relaxed for a full working day). Anything else is intentionally
 * rejected — letting an operator type "168" hours is a footgun that
 * defeats the budget cap entirely.
 *
 * The schema lives in `shared/` so the future AI Studio admin UI (#19)
 * can validate the same shape client-side without a duplicate definition.
 */

import { z } from "zod";

export const aiBudgetOverrideSchema = z.object({
  // `z.union([z.literal(1), z.literal(24)])` reads more clearly than
  // `z.number().refine(...)` and produces a precise error message.
  hours: z.union([z.literal(1), z.literal(24)]),
});

export type AiBudgetOverrideInput = z.infer<typeof aiBudgetOverrideSchema>;

/**
 * Response payload shape (the value of `data`) — exported so the SPA
 * client can type its TanStack Query hook against it.
 */
export type AiBudgetOverrideResponse = {
  /** ISO-8601 instant the override expires. */
  expiresAt: string;
  /** Echo of the requested duration so the UI can render "1h" / "24h". */
  hours: 1 | 24;
};
